export default __webpack_public_path__ + "static/media/coolspring-logo-23.03fd428c.svg";